import emailjs from '@emailjs/browser';
import 'bootstrap-icons/font/bootstrap-icons.css'; // Add this import for Bootstrap Icons
import React, { useState } from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import ScrollToTop from '../components/common/ScrollToTop';


// Initialize EmailJS
emailjs.init("yFO8mzknugOT70Ydm");

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  }); 
  const [showAlert, setShowAlert] = useState(false);
  const [alertVariant, setAlertVariant] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
      };

      await emailjs.send(
        'service_tsoicep',
        'template_ptm1bi9',
        templateParams,
        'yFO8mzknugOT70Ydm'
      );

      // Success handling
      setAlertVariant('success');
      setAlertMessage("Thank you for your message! We'll get back to you soon.");
      setShowAlert(true);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

    } catch (error) {
      // Error handling
      console.error('Email send failed:', error);
      setAlertVariant('danger');
      setAlertMessage('Sorry, there was a problem sending your message. Please try again later.');
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
      
      // Hide alert after 5 seconds
      setTimeout(() => {
        setShowAlert(false);
      }, 5000);
    }
  };
  
  return (
    <>
          <ScrollToTop />

    <div className="bg-light py-5">
      <Container>
        <h1 className="text-center fw-bold mb-5">Contact Us</h1>
        
        <Row className="justify-content-center mb-5">
          <Col md={10} lg={8}>
            <p className="text-center lead mb-5">
              Have questions about our products or services? We're here to help you find the right solutions for your business needs.
            </p>
          </Col>
        </Row>
        
        <Row className="justify-content-center">
          <Col lg={5} md={6} className="mb-4 mb-lg-0">
            <div data-aos="fade-up">
              <h4 className="mb-4">Contact Information</h4>
              <div className="contact-info">
                <div className="d-flex mb-4">
                  <div className="contact-icon me-3">
                    <i className="bi bi-geo-alt text-primary"></i>
                  </div>
                  <div>
                    <h5 className="mb-1">Address</h5>
                    <p className="mb-0"> No: 31A/52, Galwarusawa Road,<br />
                    Korathota, Kaduwela.</p>
                  </div>
                </div>
                
                <div className="d-flex mb-4">
                  <div className="contact-icon me-3">
                    <i className="bi bi-envelope text-primary"></i>
                  </div>
                  <div>
                    <h5 className="mb-1">Email</h5>
                    <p className="mb-0">
                      <a href="mailto:udara@valuecraftminds.com" className="text-decoration-none">udara@valuecraftminds.com</a>
                    </p>
                  </div>
                </div>
                
                <div className="d-flex mb-4">
                  <div className="contact-icon me-3"> 
                    <i className="bi bi-telephone text-primary"></i>
                  </div>
                  <div>
                    <h5 className="mb-1">Phone</h5>
                    <p className="mb-0">
                      <a href="tel:+94773612339" className="text-decoration-none">+94 77 361 2339</a>
                    </p>
                  </div>
                 
                </div>
               

                  <div className="d-flex mb-4">
                  <div className="contact-icon me-3"> 
                    <i className="bi bi-globe text-primary"></i> {/* Changed from telephone to globe icon */}
                  </div>
                  
                  <div>
                    <h5 className="mb-1">Official website</h5>
                    <p className="mb-0">
                      <a href="https://valuecraftminds.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">https://valuecraftminds.com</a>
                    </p>
                  </div>
                </div>  
               
              </div>
              
            </div>
          </Col>
          
          <Col lg={7} md={6}>
            <div data-aos="fade-up" data-aos-delay="200" className="contact-form-wrapper p-4 p-md-5 shadow-sm rounded bg-white">
              {showAlert && (
                <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
                  {alertMessage}
                </Alert>
              )}
              
              <Form onSubmit={handleSubmit} className='text-black'>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Your Name</Form.Label>
                      <Form.Control 
                        type="text" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleChange} 
                        disabled={isSubmitting}
                        required 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Your Email</Form.Label>
                      <Form.Control 
                        type="email" 
                        name="email" 
                        value={formData.email} 
                        onChange={handleChange} 
                        disabled={isSubmitting}
                        required 
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="subject" 
                    value={formData.subject} 
                    disabled={isSubmitting}
                    onChange={handleChange} 
                    required 
                  />
                </Form.Group>
                
                <Form.Group className="mb-4">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows={5} 
                    name="message" 
                    value={formData.message} 
                    onChange={handleChange} 
                    disabled={isSubmitting}
                    required 
                  />
                </Form.Group>
                
                <Button variant="primary" type="submit" className="rounded-pill px-4 py-2" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    </>
    
  );
};

export default ContactPage;
